// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuTitleQ_container__1QMGz","title":"MenuTitleQ_title__3xyYm","imageContainer":"MenuTitleQ_imageContainer__BpKY5","image":"MenuTitleQ_image__3jqsd"};